module.exports = __webpack_public_path__ + "img/77.9ef3675e.jpg";